module.exports = __webpack_public_path__ + "img/nav_item_bg3_no_active.5dd00388.png";